import { PointTypes } from '@/domain/point/PointTypes.enum';

const detailsPointModulePlugin = (store) => {
  store.subscribeAction(({ type, payload }) => {
    switch (type) {
      case 'shell/handleEntitySelection': {
        const { newValue } = payload;
        if (newValue && Object.values(PointTypes).includes(newValue.entityType)) {
          store.dispatch('detailsPoint/handlePointSelection', newValue.uuid, { root: true });
          break;
        }
      }
    }
  });
};

export default detailsPointModulePlugin;